import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { CusSatService } from 'app/components/cus-sat/cus-sat.service';
import { CusSatCommunicationService } from 'app/components/cus-sat/cus-sat-communication.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewModalComponent } from 'app/generic/new-modal/new-modal.component';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'cus-sat',
  templateUrl: './cus-sat.component.html',
  styleUrls: ['./cus-sat.component.scss'],
  providers: [CusSatService]
})
export class CusSatComponent implements OnInit, OnDestroy {

  reviewVote:boolean = true;
  reviewBox:boolean = false;
  reviewName:boolean = false;
  reviewDone:boolean = false;
  showCloseBtn:boolean = true;

  form: FormGroup;
  private subscription: Subscription;

  constructor(
    private restService: CusSatService,
    private fb: FormBuilder, 
    private modalService: NgbModal,
    private router:Router,
    private cusSatCommunication: CusSatCommunicationService
  ) { }

  ngOnInit() {
    this.createForm();
    
    // Nasconde il contenitore inizialmente
    setTimeout(() => {
      const elem = document.getElementById('contenitore-cus-sat');
      if (elem) {
        elem.style.bottom = '-500px';
      }
    }, 0);

    // Sottoscrizione all'evento di apertura dal footer
    this.subscription = this.cusSatCommunication.openFeedback$.subscribe(() => {
      this.openFeedbackBox();
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  createForm() {
    this.form = this.fb.group(
      {
        idVoto: ["", ],
        suggestion: ["", ],
        dataVoto: ["", ],
        voto: ["", ],
        visitMeteo: [false, ],
        visitBollettini: [false, ],
        visitAltro: [false, ],
        nomeCognome: ["", ],
        email: ["", ],
      }
     
    );
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.moveCardToTop();
    }, 70000);
  }
  

  checkConditionsPopup():boolean {
    
    var response = false;
    var currentRoute = this.router.url.split("/").length >= 3 ? this.router.url.split("/")[2] : null;
    
    if(this.getCookie('CusSatCFPC') == null || this.getCookie('CusSatCFPC') != "1"){
      if(currentRoute != null && currentRoute != 'admin'){
        response = true;
      }
    }

    return response;

  }

  moveCardToTop() {
    this.reviewVote = true;
    this.reviewBox = false;
    this.reviewName = false;
    this.reviewDone = false;
    this.showCloseBtn = true;
  
    const elem = document.getElementById('contenitore-cus-sat');
    if (elem) {
      elem.style.bottom = '5px';
    }
  }

  // Metodo pubblico per aprire il componente dall'esterno
  public openFeedbackBox(): void {
    const elem = document.getElementById('contenitore-cus-sat');
    if (elem) {
      const currentBottom = elem.style.bottom || window.getComputedStyle(elem).bottom;
      const isVisible = currentBottom !== '-500px' && currentBottom !== '' && parseFloat(currentBottom) > -500;
      
      if (!isVisible) {
        // Reset dello stato e mostra il componente
        this.moveCardToTop();
      }
      // Se è già visibile, non fare nulla (resta aperto)
    }
  }
  
  

  makeChoice(value:boolean) {

    this.form.patchValue({
      voto: value
    });

    var voto = {
      idVoto: this.form.get("idVoto").value,
      suggestion: this.form.get("suggestion").value,
      dataVoto: this.form.get("dataVoto").value,
      voto: this.form.get("voto").value,
      visitMeteo: this.form.get("visitMeteo").value,
      visitBollettini: this.form.get("visitBollettini").value,
      visitAltro: this.form.get("visitAltro").value,
      nomeCognome: this.form.get("nomeCognome").value,
      email: this.form.get("email").value,
    }
    this.restService.insertVote(voto).then(
      res => {
        if(parseInt(res) > 0){
          this.form.patchValue({
            idVoto: res
          });
        }
      }
    )
    
    this.reviewVote = false;
    this.reviewBox = true;

    this.setCookie('CusSatCFPC', '1', 365, '/');
  }

  sendReview() {
    var review = {
      idVoto: this.form.get("idVoto").value,
      suggestion: this.form.get("suggestion").value,
      dataVoto: this.form.get("dataVoto").value,
      voto: this.form.get("voto").value,
      visitMeteo: this.form.get("visitMeteo").value,
      visitBollettini: this.form.get("visitBollettini").value,
      visitAltro: this.form.get("visitAltro").value,
      nomeCognome: this.form.get("nomeCognome").value,
      email: this.form.get("email").value,
    }
    if(this.form.get("idVoto").value != null && this.form.get("idVoto").value != "" && this.form.get("idVoto").value != "0"){
      this.restService.updateVote(review);
    }else{
      this.restService.insertVote(review);
    }
    
    this.reviewVote = false;
    this.reviewBox = false;
    this.reviewName = true;
   
    
  }

  sendName() {

    if(this.validateEmail(this.form.get("email").value)){

      var name = {
        idVoto: this.form.get("idVoto").value,
        suggestion: this.form.get("suggestion").value,
        dataVoto: this.form.get("dataVoto").value,
        voto: this.form.get("voto").value,
        visitMeteo: this.form.get("visitMeteo").value,
        visitBollettini: this.form.get("visitBollettini").value,
        visitAltro: this.form.get("visitAltro").value,
        nomeCognome: this.form.get("nomeCognome").value,
        email: this.form.get("email").value,
      }
      if(this.form.get("idVoto").value != null && this.form.get("idVoto").value != "" && this.form.get("idVoto").value != "0"){
        this.restService.updateVote(name);
      }else{
        this.restService.insertVote(name);
      }
      this.reviewName = false;
      this.showCloseBtn = false;
      this.reviewDone = true;
  
      setTimeout(() => document.getElementById('contenitore-cus-sat').style.bottom = '-500px', 4000);
    
    }else{
      this.openModalResponse("ATTENZIONE", "Il formato dell'email inserita non risulta essere valido!<br>Inserisci un indirizzo email valido");
    }

  }

  closeCusSatBox() {
    document.getElementById('contenitore-cus-sat').style.bottom = '-500px';
  }

  setCookie(nome, valore, ggScadenza, path) {
    if (path == undefined) {
        path = "/";
    }
    var d = new Date();
    d.setTime(d.getTime() + (ggScadenza * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = nome + "=" + valore + "; " + expires + "; path=" + path;
  }

  getCookie(nome) {
    var name = nome + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1);
        if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
    }
    return "";
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  openModalResponse(titolo: any, messaggio: any) {
    var ref = this;
    const activeModal = this.modalService.open(NewModalComponent, { size: 'sm', container: 'nb-layout' });
    activeModal.componentInstance.modalHeader = 'Small Modal';
    activeModal.componentInstance.title = titolo;
    var strHTML =
      `<div class="row" style="margin-top: 30px;">
      <div class="col-md-12" style="text-align: center;">
        <span>`+ messaggio + `</span>
      </div>
     </div>`;
    activeModal.componentInstance.htmlToRender = strHTML; //this._sanitizer.bypassSecurityTrustHtml(strHTML);
    activeModal.componentInstance.activeModal = activeModal;
  }

}
